import * as React from "react";
import { Button } from "azure-devops-ui/Button";
import { FocusZone, FocusZoneDirection } from "azure-devops-ui/FocusZone";

export default class HorizontalExample extends React.Component {
    public render(): JSX.Element {
        return (
            <div style={{ margin: "8px" }}>
                <FocusZone direction={FocusZoneDirection.Horizontal}>
                    <div className="flex-row flex-wrap">
                        <Button text="Button1" style={{ margin: "4px" }}/>
                        <Button text="Button2" style={{ margin: "4px" }} excludeTabStop={true} />
                        <Button text="Button3" style={{ margin: "4px" }} excludeTabStop={true} />
                        <Button text="Button4" style={{ margin: "4px" }} excludeTabStop={true} />
                    </div>
                </FocusZone>
            </div>
        );
    }
}
